if (!window.Eurus.loadedScript.has('estimate-shipping-rate.js')) {
  window.Eurus.loadedScript.add('estimate-shipping-rate.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xEstimateShipping', (el, single, multiple, noRates, invalidPin, selectState, deliveryLabel, freeLabel) => ({
        countryEl: el.querySelector('.country-select'),
        provinceEl: el.querySelector('.province-select'),
        provinceContainer: el.querySelector('.province-container'),
        zip: el.querySelector('.zip-input'),
        rates: el.querySelector('.rates'),
        errors: el.querySelector('.errors'),
        loadingShipping: false,
        rates_heading: '',
        rates_text: '',
        errors_message: '',
        cachedData: {},
        cachedResponse: {},

        load() {
          this.setSelectedOption(this.countryEl, this.countryEl.dataset.default);
          this.handleCountryChange();
          this.countryEl.addEventListener('change', this.handleCountryChange.bind(this));
        },

        handleCountryChange() {
          const selectedOption = this.countryEl.options[this.countryEl.selectedIndex];
          const provinces = JSON.parse(selectedOption.dataset.provinces || '[]');
          const defaultProvince = this.provinceEl.dataset.default || '';

          this.provinceEl.replaceChildren();

          const placeholder = document.createElement('option');
          placeholder.value = '';
          placeholder.textContent = selectState;
          placeholder.disabled = true;
          placeholder.selected = true;
          this.provinceEl.appendChild(placeholder);

          provinces.forEach((province) => {
            const option = document.createElement('option');
            option.value = province[0];
            option.textContent = province[1];
            this.provinceEl.appendChild(option);
          });

          if (defaultProvince) {
            this.setSelectedOption(this.provinceEl, defaultProvince);
          }

          this.provinceContainer.hidden = provinces.length === 0;
        },

        setSelectedOption(selector, value) {
          Array.from(selector.options).forEach((option, index) => {
            if (option.value === value || option.textContent === value) {
              selector.selectedIndex = index;
            }
          });
        },

        sanitizeZip() {
          this.zip.value = this.zip.value.replace(/\D/g, '').slice(0, 6);
        },

        getDeliveryEstimate(pin) {
          const prefix2 = pin.slice(0, 2);
          const prefix3 = pin.slice(0, 3);
          const prefix5 = pin.slice(0, 5);

          if (['400', '401', '410', '421'].includes(prefix3)) return '1–3 business days';
          if (['18', '19', '78', '79'].includes(prefix2) || prefix3 === '744' || prefix5 === '68255') return '6–10 business days';
          if (['110', '122', '201', '302', '380', '382', '395', '411', '440', '500', '501', '502', '560', '562', '600', '601', '602', '603', '700', '711'].includes(prefix3)) return '3–5 business days';
          if (pin.startsWith('3') || pin.startsWith('4')) return '2–5 business days';
          return '4–7 business days';
        },

        async submit(event) {
          event?.preventDefault();
          this.sanitizeZip();
          this.errors.classList.add('hidden');
          this.rates.classList.add('hidden');

          if (!/^[1-9][0-9]{5}$/.test(this.zip.value)) {
            this.showErrors(invalidPin);
            this.zip.focus();
            return;
          }

          if (!this.provinceEl.value) {
            this.showErrors(selectState);
            this.provinceEl.focus();
            return;
          }

          const params = new URLSearchParams({
            'shipping_address[zip]': this.zip.value,
            'shipping_address[country]': this.countryEl.value,
            'shipping_address[province]': this.provinceEl.value
          }).toString();

          if (Object.prototype.hasOwnProperty.call(this.cachedData, params)) {
            if (this.cachedResponse[params]) this.showRates(this.cachedData[params]);
            else this.showErrors(this.cachedData[params]);
            return;
          }

          this.loadingShipping = true;
          try {
            const response = await fetch(`${Shopify.routes.root}cart/shipping_rates.json?${params}`);
            const data = await response.json();
            if (response.ok) this.showRates(data);
            else this.showErrors(data);
            this.cachedResponse[params] = response.ok;
            this.cachedData[params] = data;
          } catch (error) {
            this.showErrors(noRates);
          } finally {
            this.loadingShipping = false;
          }
        },

        formatRate(rate) {
          const amount = Number(rate.price);
          if (amount === 0) return freeLabel;
          return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: rate.currency || 'INR',
            maximumFractionDigits: 0
          }).format(amount);
        },

        showRates(data) {
          const ratesList = data.shipping_rates || [];
          const headingEl = this.rates.querySelector('.rates-heading');

          if (ratesList.length) {
            this.rates_heading = ratesList.length === 1 ? single : multiple;
            const estimate = this.getDeliveryEstimate(this.zip.value);
            this.rates_text = '<ul class="list-none mt-2">' + ratesList.map((rate) =>
              `<li class="pt-2 pb-2"><strong>${rate.name}: ${this.formatRate(rate)}</strong><br><span>${deliveryLabel}: ${estimate}</span></li>`
            ).join('') + '</ul>';
            headingEl.classList.remove('hidden');
          } else {
            headingEl.classList.add('hidden');
            this.rates_text = `<p class="no-rate">${noRates}</p>`;
          }

          this.rates.classList.remove('hidden');
        },

        showErrors(data) {
          let message = data;
          if (typeof data === 'object' && data !== null) {
            message = Object.values(data).flat().join(' ');
          }
          this.errors_message = `<p>${message}</p>`;
          this.errors.classList.remove('hidden');
        }
      }));

      Alpine.store('xPopupShipping', { open: false });
    });
  });
}
